import pug from 'javascripts/work_tags/templates/suggestable_tag.jst.pug';
window.JST = window.JST || {};
window.JST['work_tags/templates/suggestable_tag'] = pug;
